/**
 * optionsFormat.js — the only "formatting" the ConfigForm engine ships out of the box.
 */

export const labelFor = (options, key) => (options || []).find((option) => option.key === key)?.value ?? key ?? "";

export const labelsFor = (options, keys) => (Array.isArray(keys) ? keys : []).map((key) => labelFor(options, key));
